/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AppRouteImport } from './routes/app'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AppIndexRouteImport } from './routes/app.index'
import { Route as AdminIndexRouteImport } from './routes/admin.index'
import { Route as AppScanRouteImport } from './routes/app.scan'
import { Route as AppProfileRouteImport } from './routes/app.profile'
import { Route as AppMapRouteImport } from './routes/app.map'
import { Route as AppCertificateRouteImport } from './routes/app.certificate'
import { Route as AppBookingsRouteImport } from './routes/app.bookings'
import { Route as AppAnnouncementsRouteImport } from './routes/app.announcements'
import { Route as AppAiRouteImport } from './routes/app.ai'
import { Route as AdminVolunteersRouteImport } from './routes/admin.volunteers'
import { Route as AdminTemplesRouteImport } from './routes/admin.temples'
import { Route as AdminSettingsRouteImport } from './routes/admin.settings'
import { Route as AdminRickshawsRouteImport } from './routes/admin.rickshaws'
import { Route as AdminMembersRouteImport } from './routes/admin.members'
import { Route as AdminLoginRouteImport } from './routes/admin.login'
import { Route as AdminCertificatesRouteImport } from './routes/admin.certificates'
import { Route as AdminBookingsRouteImport } from './routes/admin.bookings'
import { Route as AdminAnnouncementsRouteImport } from './routes/admin.announcements'
import { Route as AppTemplesIndexRouteImport } from './routes/app.temples.index'
import { Route as AppTemplesIdRouteImport } from './routes/app.temples.$id'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/app',
  path: '/app',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRoute,
} as any)
const AppScanRoute = AppScanRouteImport.update({
  id: '/scan',
  path: '/scan',
  getParentRoute: () => AppRoute,
} as any)
const AppProfileRoute = AppProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AppRoute,
} as any)
const AppMapRoute = AppMapRouteImport.update({
  id: '/map',
  path: '/map',
  getParentRoute: () => AppRoute,
} as any)
const AppCertificateRoute = AppCertificateRouteImport.update({
  id: '/certificate',
  path: '/certificate',
  getParentRoute: () => AppRoute,
} as any)
const AppBookingsRoute = AppBookingsRouteImport.update({
  id: '/bookings',
  path: '/bookings',
  getParentRoute: () => AppRoute,
} as any)
const AppAnnouncementsRoute = AppAnnouncementsRouteImport.update({
  id: '/announcements',
  path: '/announcements',
  getParentRoute: () => AppRoute,
} as any)
const AppAiRoute = AppAiRouteImport.update({
  id: '/ai',
  path: '/ai',
  getParentRoute: () => AppRoute,
} as any)
const AdminVolunteersRoute = AdminVolunteersRouteImport.update({
  id: '/volunteers',
  path: '/volunteers',
  getParentRoute: () => AdminRoute,
} as any)
const AdminTemplesRoute = AdminTemplesRouteImport.update({
  id: '/temples',
  path: '/temples',
  getParentRoute: () => AdminRoute,
} as any)
const AdminSettingsRoute = AdminSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AdminRoute,
} as any)
const AdminRickshawsRoute = AdminRickshawsRouteImport.update({
  id: '/rickshaws',
  path: '/rickshaws',
  getParentRoute: () => AdminRoute,
} as any)
const AdminMembersRoute = AdminMembersRouteImport.update({
  id: '/members',
  path: '/members',
  getParentRoute: () => AdminRoute,
} as any)
const AdminLoginRoute = AdminLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AdminRoute,
} as any)
const AdminCertificatesRoute = AdminCertificatesRouteImport.update({
  id: '/certificates',
  path: '/certificates',
  getParentRoute: () => AdminRoute,
} as any)
const AdminBookingsRoute = AdminBookingsRouteImport.update({
  id: '/bookings',
  path: '/bookings',
  getParentRoute: () => AdminRoute,
} as any)
const AdminAnnouncementsRoute = AdminAnnouncementsRouteImport.update({
  id: '/announcements',
  path: '/announcements',
  getParentRoute: () => AdminRoute,
} as any)
const AppTemplesIndexRoute = AppTemplesIndexRouteImport.update({
  id: '/temples/',
  path: '/temples/',
  getParentRoute: () => AppRoute,
} as any)
const AppTemplesIdRoute = AppTemplesIdRouteImport.update({
  id: '/temples/$id',
  path: '/temples/$id',
  getParentRoute: () => AppRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/app': typeof AppRouteWithChildren
  '/login': typeof LoginRoute
  '/admin/announcements': typeof AdminAnnouncementsRoute
  '/admin/bookings': typeof AdminBookingsRoute
  '/admin/certificates': typeof AdminCertificatesRoute
  '/admin/login': typeof AdminLoginRoute
  '/admin/members': typeof AdminMembersRoute
  '/admin/rickshaws': typeof AdminRickshawsRoute
  '/admin/settings': typeof AdminSettingsRoute
  '/admin/temples': typeof AdminTemplesRoute
  '/admin/volunteers': typeof AdminVolunteersRoute
  '/app/ai': typeof AppAiRoute
  '/app/announcements': typeof AppAnnouncementsRoute
  '/app/bookings': typeof AppBookingsRoute
  '/app/certificate': typeof AppCertificateRoute
  '/app/map': typeof AppMapRoute
  '/app/profile': typeof AppProfileRoute
  '/app/scan': typeof AppScanRoute
  '/admin/': typeof AdminIndexRoute
  '/app/': typeof AppIndexRoute
  '/app/temples/$id': typeof AppTemplesIdRoute
  '/app/temples/': typeof AppTemplesIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/admin/announcements': typeof AdminAnnouncementsRoute
  '/admin/bookings': typeof AdminBookingsRoute
  '/admin/certificates': typeof AdminCertificatesRoute
  '/admin/login': typeof AdminLoginRoute
  '/admin/members': typeof AdminMembersRoute
  '/admin/rickshaws': typeof AdminRickshawsRoute
  '/admin/settings': typeof AdminSettingsRoute
  '/admin/temples': typeof AdminTemplesRoute
  '/admin/volunteers': typeof AdminVolunteersRoute
  '/app/ai': typeof AppAiRoute
  '/app/announcements': typeof AppAnnouncementsRoute
  '/app/bookings': typeof AppBookingsRoute
  '/app/certificate': typeof AppCertificateRoute
  '/app/map': typeof AppMapRoute
  '/app/profile': typeof AppProfileRoute
  '/app/scan': typeof AppScanRoute
  '/admin': typeof AdminIndexRoute
  '/app': typeof AppIndexRoute
  '/app/temples/$id': typeof AppTemplesIdRoute
  '/app/temples': typeof AppTemplesIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/app': typeof AppRouteWithChildren
  '/login': typeof LoginRoute
  '/admin/announcements': typeof AdminAnnouncementsRoute
  '/admin/bookings': typeof AdminBookingsRoute
  '/admin/certificates': typeof AdminCertificatesRoute
  '/admin/login': typeof AdminLoginRoute
  '/admin/members': typeof AdminMembersRoute
  '/admin/rickshaws': typeof AdminRickshawsRoute
  '/admin/settings': typeof AdminSettingsRoute
  '/admin/temples': typeof AdminTemplesRoute
  '/admin/volunteers': typeof AdminVolunteersRoute
  '/app/ai': typeof AppAiRoute
  '/app/announcements': typeof AppAnnouncementsRoute
  '/app/bookings': typeof AppBookingsRoute
  '/app/certificate': typeof AppCertificateRoute
  '/app/map': typeof AppMapRoute
  '/app/profile': typeof AppProfileRoute
  '/app/scan': typeof AppScanRoute
  '/admin/': typeof AdminIndexRoute
  '/app/': typeof AppIndexRoute
  '/app/temples/$id': typeof AppTemplesIdRoute
  '/app/temples/': typeof AppTemplesIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/app'
    | '/login'
    | '/admin/announcements'
    | '/admin/bookings'
    | '/admin/certificates'
    | '/admin/login'
    | '/admin/members'
    | '/admin/rickshaws'
    | '/admin/settings'
    | '/admin/temples'
    | '/admin/volunteers'
    | '/app/ai'
    | '/app/announcements'
    | '/app/bookings'
    | '/app/certificate'
    | '/app/map'
    | '/app/profile'
    | '/app/scan'
    | '/admin/'
    | '/app/'
    | '/app/temples/$id'
    | '/app/temples/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/admin/announcements'
    | '/admin/bookings'
    | '/admin/certificates'
    | '/admin/login'
    | '/admin/members'
    | '/admin/rickshaws'
    | '/admin/settings'
    | '/admin/temples'
    | '/admin/volunteers'
    | '/app/ai'
    | '/app/announcements'
    | '/app/bookings'
    | '/app/certificate'
    | '/app/map'
    | '/app/profile'
    | '/app/scan'
    | '/admin'
    | '/app'
    | '/app/temples/$id'
    | '/app/temples'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/app'
    | '/login'
    | '/admin/announcements'
    | '/admin/bookings'
    | '/admin/certificates'
    | '/admin/login'
    | '/admin/members'
    | '/admin/rickshaws'
    | '/admin/settings'
    | '/admin/temples'
    | '/admin/volunteers'
    | '/app/ai'
    | '/app/announcements'
    | '/app/bookings'
    | '/app/certificate'
    | '/app/map'
    | '/app/profile'
    | '/app/scan'
    | '/admin/'
    | '/app/'
    | '/app/temples/$id'
    | '/app/temples/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRoute: typeof AdminRouteWithChildren
  AppRoute: typeof AppRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app': {
      id: '/app'
      path: '/app'
      fullPath: '/app'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/': {
      id: '/app/'
      path: '/'
      fullPath: '/app/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/admin/': {
      id: '/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/app/scan': {
      id: '/app/scan'
      path: '/scan'
      fullPath: '/app/scan'
      preLoaderRoute: typeof AppScanRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/profile': {
      id: '/app/profile'
      path: '/profile'
      fullPath: '/app/profile'
      preLoaderRoute: typeof AppProfileRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/map': {
      id: '/app/map'
      path: '/map'
      fullPath: '/app/map'
      preLoaderRoute: typeof AppMapRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/certificate': {
      id: '/app/certificate'
      path: '/certificate'
      fullPath: '/app/certificate'
      preLoaderRoute: typeof AppCertificateRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/bookings': {
      id: '/app/bookings'
      path: '/bookings'
      fullPath: '/app/bookings'
      preLoaderRoute: typeof AppBookingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/announcements': {
      id: '/app/announcements'
      path: '/announcements'
      fullPath: '/app/announcements'
      preLoaderRoute: typeof AppAnnouncementsRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/ai': {
      id: '/app/ai'
      path: '/ai'
      fullPath: '/app/ai'
      preLoaderRoute: typeof AppAiRouteImport
      parentRoute: typeof AppRoute
    }
    '/admin/volunteers': {
      id: '/admin/volunteers'
      path: '/volunteers'
      fullPath: '/admin/volunteers'
      preLoaderRoute: typeof AdminVolunteersRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/temples': {
      id: '/admin/temples'
      path: '/temples'
      fullPath: '/admin/temples'
      preLoaderRoute: typeof AdminTemplesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/settings': {
      id: '/admin/settings'
      path: '/settings'
      fullPath: '/admin/settings'
      preLoaderRoute: typeof AdminSettingsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/rickshaws': {
      id: '/admin/rickshaws'
      path: '/rickshaws'
      fullPath: '/admin/rickshaws'
      preLoaderRoute: typeof AdminRickshawsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/members': {
      id: '/admin/members'
      path: '/members'
      fullPath: '/admin/members'
      preLoaderRoute: typeof AdminMembersRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/login': {
      id: '/admin/login'
      path: '/login'
      fullPath: '/admin/login'
      preLoaderRoute: typeof AdminLoginRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/certificates': {
      id: '/admin/certificates'
      path: '/certificates'
      fullPath: '/admin/certificates'
      preLoaderRoute: typeof AdminCertificatesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/bookings': {
      id: '/admin/bookings'
      path: '/bookings'
      fullPath: '/admin/bookings'
      preLoaderRoute: typeof AdminBookingsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/announcements': {
      id: '/admin/announcements'
      path: '/announcements'
      fullPath: '/admin/announcements'
      preLoaderRoute: typeof AdminAnnouncementsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/app/temples/': {
      id: '/app/temples/'
      path: '/temples'
      fullPath: '/app/temples/'
      preLoaderRoute: typeof AppTemplesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/temples/$id': {
      id: '/app/temples/$id'
      path: '/temples/$id'
      fullPath: '/app/temples/$id'
      preLoaderRoute: typeof AppTemplesIdRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AdminRouteChildren {
  AdminAnnouncementsRoute: typeof AdminAnnouncementsRoute
  AdminBookingsRoute: typeof AdminBookingsRoute
  AdminCertificatesRoute: typeof AdminCertificatesRoute
  AdminLoginRoute: typeof AdminLoginRoute
  AdminMembersRoute: typeof AdminMembersRoute
  AdminRickshawsRoute: typeof AdminRickshawsRoute
  AdminSettingsRoute: typeof AdminSettingsRoute
  AdminTemplesRoute: typeof AdminTemplesRoute
  AdminVolunteersRoute: typeof AdminVolunteersRoute
  AdminIndexRoute: typeof AdminIndexRoute
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminAnnouncementsRoute: AdminAnnouncementsRoute,
  AdminBookingsRoute: AdminBookingsRoute,
  AdminCertificatesRoute: AdminCertificatesRoute,
  AdminLoginRoute: AdminLoginRoute,
  AdminMembersRoute: AdminMembersRoute,
  AdminRickshawsRoute: AdminRickshawsRoute,
  AdminSettingsRoute: AdminSettingsRoute,
  AdminTemplesRoute: AdminTemplesRoute,
  AdminVolunteersRoute: AdminVolunteersRoute,
  AdminIndexRoute: AdminIndexRoute,
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

interface AppRouteChildren {
  AppAiRoute: typeof AppAiRoute
  AppAnnouncementsRoute: typeof AppAnnouncementsRoute
  AppBookingsRoute: typeof AppBookingsRoute
  AppCertificateRoute: typeof AppCertificateRoute
  AppMapRoute: typeof AppMapRoute
  AppProfileRoute: typeof AppProfileRoute
  AppScanRoute: typeof AppScanRoute
  AppIndexRoute: typeof AppIndexRoute
  AppTemplesIdRoute: typeof AppTemplesIdRoute
  AppTemplesIndexRoute: typeof AppTemplesIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAiRoute: AppAiRoute,
  AppAnnouncementsRoute: AppAnnouncementsRoute,
  AppBookingsRoute: AppBookingsRoute,
  AppCertificateRoute: AppCertificateRoute,
  AppMapRoute: AppMapRoute,
  AppProfileRoute: AppProfileRoute,
  AppScanRoute: AppScanRoute,
  AppIndexRoute: AppIndexRoute,
  AppTemplesIdRoute: AppTemplesIdRoute,
  AppTemplesIndexRoute: AppTemplesIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRoute: AdminRouteWithChildren,
  AppRoute: AppRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
